<template>
    <div class="min-h-screen bg-slate-50 dark:bg-slate-900">
        <KanbanView />
    </div>
</template>

<script setup>
import KanbanView from '../Presupuestos/components/KanbanView.vue'
</script>
